import React from 'react';
import { SectionHeader } from '../common/SharedComponents';
import EditBrokerClientModal from './modals/EditBrokerClientModal';
import PendingBrokerClientTable from './tables/PendingBrokerClientTable';
import InitialExpiryBrokerClientTable from './tables/InitialExpiryBrokerClientTable';
import ActiveBrokerClientTable from './tables/ActiveBrokerClientTable';
import ExpiredBrokerClientTable from './tables/ExpiredBrokerClientTable';
import RejectedBrokerClientTable from './tables/RejectedBrokerClientTable';
import store, { brokerClientActions, searchActions } from '@apply/adminStore';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

function BrokerClientSummary() {
    const searchState = useSelector((state) => state.searchState);
    const { dispatch } = store;

    const _handleAddBrokerClient = () => {
        dispatch(brokerClientActions.setBrokerClientId({ brokerClientId: null }));
        dispatch(
            brokerClientActions.setBrokerClientOpen({
                openBrokerClientModal: true,
            })
        );
    };

    const _onSearchChange = (event) => {
        dispatch(
            searchActions.setSearchText({
                searchText: {
                    ...searchState.searchText,
                    brokerClient: event.target.value,
                },
            })
        );
    };

    return (
        <>
            <SectionHeader
                title='B-Clients'
                buttonText='Add Broker Client'
                buttonCallback={_handleAddBrokerClient}
            />
            <div
                className='main-content'
                style={{ padding: 0, backgroundColor: '#f4f4f4' }}
            >
                <div className='input-has-icon main-search'>
                    <input
                        type='search'
                        placeholder='Search to Filter Broker Clients'
                        value={searchState.searchText?.brokerClient}
                        onChange={_onSearchChange}
                    />
                    <FontAwesomeIcon
                        icon={faSearch}
                        aria-hidden='true'
                        className='icon'
                    />
                </div>
                <div className='scrollable-content'>
                    <div
                        className='accordion'
                        data-accordion=''
                        data-allow-all-closed='true'
                        data-multi-expand='true'
                    >
                        <PendingBrokerClientTable />
                        <InitialExpiryBrokerClientTable />
                        <ActiveBrokerClientTable />
                        <ExpiredBrokerClientTable />
                        <RejectedBrokerClientTable />
                    </div>
                </div>
            </div>
            <EditBrokerClientModal />
        </>
    );
}

export default BrokerClientSummary;
